export default __webpack_public_path__ + "static/blob11-9991faf889b34807bd5bb212b9de029c.svg";